/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  Button,
} from "@nextui-org/react";
import { LanguageIcon } from "@heroicons/react/24/outline";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function SelectLang({ isHeader }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLanguageChange = (lng) => {
    i18n.changeLanguage(lng).then(() => {
      document.title = t("siteTitle");
      localStorage.setItem("lng", lng);
      localStorage.setItem("dir", lng === "fa" || lng === "ar" ? "rtl" : "ltr");
      document.documentElement.setAttribute(
        "dir",
        lng === "fa" || lng === "ar" ? "rtl" : "ltr"
      );

      let newPath = location.pathname.replace(/\/(en|fa|ar|ru)/, `/${lng}`);

      if (newPath === location.pathname) {
        newPath = `/${lng}${newPath}`;
      }

      navigate(newPath);
    });
  };

  return (
    <div className="flex">
      {isHeader ? (
        <div className=" flex items-center gap-1 lg:gap-4  2xl:gap-5  xl:px-1 2xl:px-3 ">
          <div
            className="flex flex-row items-center md:gap-1 cursor-pointer"
            onClick={() => handleLanguageChange("fa")}
          >
            <p className="font-bold hidden lg:block lg:mt-0.5 hover:text-primary-300">
              فارسی
            </p>
            <img
              src="../../Assets/Images/icons/icons8-iran-48.png"
              className="h-7 mb-0.5 lg:mb-0 lg:mt-0.5 "
            />
          </div>

          <div
            className="flex flex-row items-center md:gap-2 cursor-pointer  "
            onClick={() => handleLanguageChange("en")}
          >
            <p className="font-bold hidden lg:block lg:mt-2 hover:text-primary-300">
              English
            </p>
            <img
              src="../../Assets/Images/icons/icons8-usa-48.png"
              className="h-7 "
            />
          </div>

          <div
            className="flex flex-row items-center md:gap-2 cursor-pointer "
            onClick={() => handleLanguageChange("ar")}
          >
            <p className="font-bold hidden lg:block lg:mt-2 hover:text-primary-300">
              العربية
            </p>
            <img
              src="../../Assets/Images/icons/irq.jpg"
              className="h-4 lg:mt-1"
            />
          </div>

          <div
            className="flex flex-row items-center md:gap-2 cursor-pointer"
            onClick={() => handleLanguageChange("ru")}
          >
            <p className="font-bold hidden lg:block lg:mt-2 hover:text-primary-300">
              Русский
            </p>
            <img
              src="../../Assets/Images/icons/icons8-russia-48.png"
              className="h-5 w-8 mb-1 lg:mb-0"
            />
          </div>
        </div>
      ) : (
        <Dropdown showArrow>
          <DropdownTrigger>
            <Button
              variant="bordered"
              className="text-black text-medium"
              size="sm"
            >
              <span className="pt-1 text-black">Language</span>
              <LanguageIcon className="h-4 w-4" />
            </Button>
          </DropdownTrigger>

          <DropdownMenu aria-label="User Actions" variant="flat">
            <DropdownItem
              key="fa"
              className="h-14"
              onClick={() => handleLanguageChange("fa")}
            >
              <div className="flex flex-row items-center gap-2 ">
                <img
                  src="../../Assets/Images/icons/icons8-iran-48.png"
                  className="h-7 w-9"
                />
                <p className="text-black  font-bold">فارسی</p>
              </div>
            </DropdownItem>

            <DropdownItem
              key="en"
              className="h-14"
              onClick={() => handleLanguageChange("en")}
            >
              <div className="flex flex-row items-center gap-2">
                <img
                  src="../../Assets/Images/icons/icons8-usa-48.png"
                  className="h-7 w-9"
                />
                <p className="font-bold">English</p>
              </div>
            </DropdownItem>

            <DropdownItem
              key="ar"
              className="h-14"
              onClick={() => handleLanguageChange("ar")}
            >
              <div className="flex flex-row items-center gap-2">
                <img
                  src="../../Assets/Images/icons/icons8-kuwait-48.png"
                  className="h-7 w-9"
                />
                <p className="font-bold">العربية</p>
              </div>
            </DropdownItem>

            <DropdownItem
              key="ru"
              className="h-14"
              onClick={() => handleLanguageChange("ru")}
            >
              <div className="flex flex-row items-center gap-2">
                <img
                  src="../../Assets/Images/icons/icons8-russia-48.png"
                  className="h-7 w-9"
                />
                <p className="font-bold">Русский</p>
              </div>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      )}
    </div>
  );
}
